import { useForm } from '@inertiajs/inertia-react';
import Icon from 'app/components/Icon';
import { MODALS, ModalsContext } from 'app/components/Layouts/Modals';
import React, { useContext, useEffect } from 'react'
import route from 'ziggy-js';
import Form from '../Forms/Form';
import Select from '../Forms/Select';
import SelectMultiple from '../Forms/SelectMultiple';
import Submit from '../Forms/Submit';
import TextField from '../Forms/TextField';
import CloseBtn from './CloseBtn';
import ModalLayout from './ModalLayout';

interface Props { }

function NewProject(props: Props) {
    const { } = props

    const form = useForm({});
    const { data, post } = form;

    const submit = (e) => {
        e.preventDefault();
        post(route('projects.store'));
    }

    return (
        <ModalLayout>
            <div className='p-20px pt-67px relative bg-gray rounded-default w-1/3 mob:w-full'>
                <CloseBtn />
                <div className='text-18 mb-12px text-white'>New project</div>
                <Form form={form} onSubmit={submit}>
                    <TextField placeholder='Enter name' label={"Project name"} name="name" />
                    {/* <Select options={[
                        {text:"Project name",value:"text"}
                    ]}
                    placeholder="Choose a project" />
                    <SelectMultiple label={"Team"} options={[
                        {text:"Svobo",value:"1"},
                        {text:"Dejv",value:"2"}
                    ]} /> */}
                    <Submit className='w-full' value="Add" />
                </Form>
            </div>
        </ModalLayout>
    )
}

export default NewProject
